import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

import { siteConfig } from '@/configs/siteConfig';

import { siteState } from '@/modules/siteState/siteStateGetter';

// const props = {};

export const gsapManager = {
  init() {
    this.common();
  },

  common() {
    const horizontal = (document.getElementById('js-gsapSlideX') as HTMLElement) || null;
    const progressBar = (document.getElementById('js-progressBar') as HTMLElement) || null;

    if (horizontal && progressBar) {
      const horizontalWidth = horizontal.offsetWidth;
      const firstPanelWidth = (horizontal.children[0] as HTMLElement).offsetWidth;
      const xSlide = horizontalWidth - firstPanelWidth;
      const startShift = siteState.winWidth < siteConfig.breakpoint.shiftPoint ? 60 : 130;

      gsap.to(horizontal, {
        x: `-${xSlide}px`,
        ease: 'none',
        scrollTrigger: {
          trigger: horizontal.parentElement,
          pin: true,
          scrub: 1,
          start: `-=${startShift}`,
          end: `+=${horizontal.offsetWidth}`,
          // markers: true,
          onUpdate: (self) => {
            const progress = Math.min(Math.max(self.progress, 0), 1); // 0-1 に制限
            progressBar.style.width = `${progress * 100}%`;
          },
        },
      });
    }

    gsap.utils.toArray<HTMLElement>('.js-gsapBlur').forEach((el) => {
      gsap.to(el, {
        filter: 'blur(0px)',
        scrollTrigger: {
          trigger: el,
          start: 'top 80%',
          end: 'bottom+=100 80%',
          scrub: true,
          // markers: true,
        },
      });
    });

    gsap.utils.toArray<HTMLElement>('.js-gsapParallax').forEach((el) => {
      const y = Number(el.dataset.y) || 50;

      gsap.fromTo(
        el,
        {
          yPercent: y,
        },
        {
          yPercent: y * -1,
          ease: 'none',
          scrollTrigger: {
            trigger: el,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
            // markers: true,
          },
        },
      );
    });

    gsap.utils.toArray<HTMLElement>('.js-gsapScale').forEach((el) => {
      gsap.to(el, {
        scale: 0.8,
        scrollTrigger: {
          trigger: el,
          start: 'bottom+=25% 90%',
          end: 'bottom+=140% 90%',
          scrub: true,
          // markers: true,
        },
      });
    });
  },
};
